(ns dre.components.searchbar.subs
  (:require
   [clj-commons.humanize :refer [intcomma]]
   [dre.components.icon :as icon]
   [dre.page-util :as page-util]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db [_ db-root-path]]
   (get-in db db-root-path)))

(rf/reg-sub
 ::suggestions
 (fn [[_ db-root-path]]
   (rf/subscribe [::state db-root-path]))
 (fn [state _]
   (get-in state [:suggestions :current])))

(rf/reg-sub
 ::search-input-hint
 (fn [[_ db-root-path]]
   (rf/subscribe [::state db-root-path]))
 (fn [{:keys [counts]} _]
   (cond
     (:loading? counts) [:<> [icon/fa-icon :spinner {:spin true}] "Estimating results"]
     (:current counts) (let [current (:current counts)
                             count (-> current :search/count intcomma)
                             count-6m (-> current :search/count-6m intcomma)
                             count-1w (-> current :search/count-1w intcomma)]
                         [:<>
                          "About " [:b count] " results ("
                          [:b count-6m] " in past 6 months, "
                          [:b count-1w] " in the past week)"])
     :else nil)))

(rf/reg-sub
 ::search-query
 (fn [[_ db-root-path]]
   (rf/subscribe [::state db-root-path]))
 (fn [state _]
   (:search-query state)))

(rf/reg-sub
 ::time-travel
 (fn [[_ db-root-path]]
   (rf/subscribe [::state db-root-path]))
 (fn [state _]
   (:time-travel state)))

(rf/reg-sub
 ::past
 (fn [[_ db-root-path]]
   (rf/subscribe [::time-travel db-root-path]))
 (fn [time-travel _]
   (:past time-travel)))

(rf/reg-sub
 ::future
 (fn [[_ db-root-path]]
   (rf/subscribe [::time-travel db-root-path]))
 (fn [time-travel _]
   (:future time-travel)))

(rf/reg-sub
 ::undo-disabled?
 (fn [[_ db-root-path]]
   (rf/subscribe [::past db-root-path]))
 (fn [past _]
   (-> past seq boolean not)))

(rf/reg-sub
 ::redo-disabled?
 (fn [[_ db-root-path]]
   (rf/subscribe [::future db-root-path]))
 (fn [future _]
   (-> future seq boolean not)))

(rf/reg-sub
 ::pills
 (fn [[_ db-root-path]]
   (rf/subscribe [::search-query db-root-path]))
 (fn [search-query _]
   (:query/pills search-query)))

(rf/reg-sub
 ::pill-count
 (fn [[_ db-root-path]]
   (rf/subscribe [::pills db-root-path]))
 (fn [pills _]
   (page-util/count-pills pills)))


(rf/reg-sub
 ::pills-empty?
 (fn [[_ db-root-path]]
   (rf/subscribe [::pills db-root-path]))
 (fn [pills _]
   (empty? pills)))

(rf/reg-sub
 ::search-disabled?
 (fn [[_ db-root-path]]
   (rf/subscribe [::pill-count db-root-path]))
 (fn [pill-count _]
   (or (nil? pill-count)
       (= pill-count 0))))

(rf/reg-sub
 ::caret-position
 (fn [[_ db-root-path]]
   (rf/subscribe [::state db-root-path]))
 (fn [state _]
   (:caret-position state)))

(rf/reg-sub
 ::caret-position-nil?
 (fn [[_ db-root-path _]]
   (rf/subscribe [::caret-position db-root-path]))
 (fn [caret-position [_ _ i]]
   (nil? caret-position)))